import { render, staticRenderFns } from "./KomunitasList.vue?vue&type=template&id=8f88c998"
import script from "./KomunitasList.vue?vue&type=script&lang=js"
export * from "./KomunitasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports